export default {
    name: 'email-addresses',
    props: {
        userData: Object,
        emailAddresses: Object,
        loadUserData: Function
    },
    data() {
        return {
            codes: [],
            tempPhoneNumber: '',
            emailToRemove: '',
            message: null,
            messageClass: null,
            messageTextClass: null,
            messageTimer: null,
            messageScope: null,
            messageScopes: {
                page: 1,
                modal: 2
            },
            emailRegEx: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            verifyEmailDialog: false,
            removeEmailDialog: false,
            emailVerifying: false,
            autoVerifyEnabled: true,
            //Rules
            emailAddressRules: [
                v => (v && this.emailRegEx.test(v)) || 'This is not a valid email address',
                v => (this.emailAddresses.assignedEmails.filter((e) => e.email == v).length === 0) || 'This email address already exists'
            ]
        }
    },
    computed: {
        emailAddressValid() {
            return this.emailAddresses != null
                && this.emailAddresses.email !== null
                && this.emailAddresses.assignedEmails.filter((e) => e.email == this.emailAddresses.email).length === 0
                && this.emailRegEx.test(this.emailAddresses.email)
        },
        emailVerificationCodeValid() {
            return this.codes != null && this.codes.length == 6 && this.codes.filter((code) => code.value != '').length === 6;
        }
    },
    mounted() {
        this.codes = new Array({ value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' });
        this.messageScope = this.messageScopes.page;
    },
    watch: {
        'codes': {
            deep: true,

            handler(newValue) {
                if (this.autoVerifyEnabled &&
                    newValue && newValue.length == 6 &&
                    newValue.filter((code) => code.value != '').length === 6) {
                    this.emailVerifying = true;
                    this.autoVerifyEnabled = false;
                    this.verifyEmail();
                }
            }
        },
        'verifyEmailDialog'(newValue, oldValue) {
            if (newValue && !oldValue) {
                this.autoVerifyEnabled = true;
            }
        }
    },
    methods: {
        sendVerificationCode(e) {
            let self = this,
                data = {
                    Id: self.userData.profile.sub,
                    Email: self.emailAddresses.email,
                    PhoneNumber: self.getNewGUID()
                };

            if (self.emailAddressValid) {
                self.codes = new Array({ value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' });
                self.$state.set("loading", true);
                self.$api.sendEmailVerificationCode(self.userData, data, function (response) {
                    let message = response.status != 200 &&
                        response.data ?
                        response.data.value : null;
                    self.$state.set("loading", false);
                    self.showMessage(message || 'Verification Code sending failed', 'error-message', 'error--text', self.messageScopes.page);
                }).then(function (responseData) {
                    if (responseData) {
                        self.$state.set("loading", false);

                        self.verifyEmailDialog = true;
                        self.tempPhoneNumber = data.PhoneNumber;
                        setTimeout(() => self.$refs.code0[0].focus(), 100);
                    }
                });
            } else {
                e.preventDefault();
                return false;
            }
        },

        verifyEmail(e) {
            let self = this,
                data = {
                    Id: self.userData.profile.sub,
                    Email: self.emailAddresses.email,
                    PhoneNumber: self.tempPhoneNumber,
                    VerificationCode: self.codes.map(item => item.value).join('')
                };

            if (self.emailVerificationCodeValid) {
                this.$state.set("loading", true);
                self.$api.verifyUserEmail(self.userData, data, function (response) {
                    let message = response.status != 200 &&
                        response.data ?
                        response.data.value : null;
                    self.emailVerifying = false;
                    self.$state.set("loading", false);
                    self.showMessage(message || 'Verifying User Email failed', 'error-message', 'error--text', self.messageScopes.modal);
                }).then(function (responseData) {
                    if (responseData) {
                        self.$state.set("loading", false);

                        self.emailVerifying = false;
                        self.verifyEmailDialog = false;
                        self.tempPhoneNumber = null;
                        self.codes = new Array({ value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' });
                        self.emailAddresses.assignedEmails = responseData.slice();
                        self.emailAddresses.email = '';
                        self.$refs.myEmailAddressesForm.reset();
                        self.showMessage('Email added successfully', 'success-message', 'success--text', self.messageScopes.page);
                    }
                });
            } else {
                e.preventDefault();
                return false;
            }
        },

        removeEmail(email) {
            this.emailToRemove = email;
            this.removeEmailDialog = true;
        },

        confirmRemoveEmail(email) {
            let self = this,
                data = {
                    Id: self.userData.profile.sub,
                    Email: email,
                };

            this.$state.set("loading", true);
            self.$api.removeUserEmail(self.userData, data, function (response) {
                let message = response.status != 200 &&
                    response.data ?
                    response.data.value : null;
                self.$state.set("loading", false);
                self.showMessage(message || 'Removing email failed', 'error-message', 'error--text', self.messageScopes.modal);
            }).then(function (responseData) {
                if (responseData) {
                    self.$state.set("loading", false);

                    self.removeEmailDialog = false;
                    self.emailToRemove = null;
                    self.emailAddresses.assignedEmails = responseData.slice();
                    self.showMessage('Email removed successfully', 'success-message', 'success--text', self.messageScopes.page);
                }
            });
        },

        showMessage(message, messageClass, messageTextClass, messageScope) {
            let self = this;

            self.message = message;
            self.messageClass = messageClass;
            self.messageTextClass = messageTextClass;
            self.messageScope = messageScope;

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.clearMessage(messageClass);
            }, 3000);
        },

        clearMessage(messageClass) {
            let self = this;

            self.messageClass = messageClass + ' fade-out';

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.message = null;
                self.messageClass = null;
                self.messageTextClass = null;
            }, 700);
        },

        getNewGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        goToNextInput(e) {
            var key = e.which,
                target = e.target,
                nextSibling = target.nextElementSibling,
                prevSibling = target.previousElementSibling;

            if (key != 9 && key != 8 && (key < 48 || key > 57) && (key < 96 || key > 105)) {
                if (key !== 86) {
                    e.preventDefault();
                    return false;
                }
            }

            if (key === 9) {
                return true;
            }

            if (key === 8) {
                target.value = null;

                if (!prevSibling) {
                    prevSibling = target.parentNode.children[target.parentNode.children.length - 1];
                }

                prevSibling.focus();

                return true;
            }

            if (!nextSibling) {
                nextSibling = target.parentNode.children[0];
            }

            if (key !== 86) { //V - in case of paste.
                this.codes[[].slice.call(target.parentNode.children).indexOf(target)].value = e.key;
                this.codes = this.codes.slice();
                nextSibling.focus();
            }
        },

        onKeyDown(e) {
            let self = this,
                key = e.which;

            if (key === 9 || key === 8 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
                self.codes = self.codes.slice();
                return true;
            }

            if (key !== 86) { //V - in case of paste.
                e.preventDefault();
                return false;
            }
        },

        onFocus(e) {
            e.target.focus();
        },

        onPaste(e) {
            var self = this, clipboardData, pastedData;

            e.stopPropagation();
            e.preventDefault();

            clipboardData = e.clipboardData || window.clipboardData;
            pastedData = clipboardData.getData('Text');

            if (pastedData && pastedData.length == 6 && parseInt(pastedData)) {
                [].slice.call(pastedData).forEach(function (char, index) {
                    self.codes[index].value = char;
                });

                self.codes = self.codes.slice();
            }
        }
    }
}
